export const hasSalesRole = (user, role) => {
  if (!user || !user.branch || !user.equipment || !user.equipment.roles) {
    return false;
  }

  if (user.equipment.roles[user.branch.id] && user.equipment.roles[user.branch.id].includes(role)) {
    return true;
  }

  return false;
};

export const getSalesRoles = user => {
  return {
    isSalesPerson: hasSalesRole(user, 'SP'),
    isSalesManager: hasSalesRole(user, 'SM'),
    isSalesAccountant: hasSalesRole(user, 'A'),
  };
};

export const getCustomerName = (customer) => {
  // Old key
  if (customer.Name) {
    return customer.Name;
  }

  // Use First/Last if it's given
  if (customer['First Name'] && customer['Last Name']) {
    return `${customer['First Name']} ${customer['Last Name']}`;
  }

  // Fallback on company name
  return customer['Company Name'];
};

export const glCodeFieldName = 'G/L Code';
